import React, { useEffect, useState, Suspense, lazy, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Helmet from "react-helmet";
import HeaderNavbar from "../components/Header";
import Banner from "../components/LOBanner/LOBanner";
import MediaQuery from "react-responsive";

import { getSortedJsonWrtDates } from "./PressReleased/helpers";

import Loader from "../components/Loader/Loader.js";

import jsonData from "./ai-branding.json"; // Import the JSON

const Footer = lazy(() => import("./CommenFooterComponent/index"));

const AngelSection = lazy(() => import("./AngelSection/AngelSection"));
const ForbeCarousel = lazy(() => import("./ForbeCarousel/Forbecarousel"));
const Broadcast = lazy(() => import("./PriorBroadcasts/PriorBroadcasts"));

const AboutSection = lazy(() => import("./AboutSection/AboutSection"));
const PressRelease = lazy(() => import("./PressReleased/PressRelease"));

export default function LoanOfficerHome() {
  //get name details from url params
  const { loanofficername } = useParams();
  //Make loanofficername lowercase to prevent issues with capital letters in url
  const lowerCaseLoanOfficerName = loanofficername.slice().toLowerCase();
  const [dpaData, setDPAData] = useState();
  const [loanOfficer, setLoanOfficer] = useState();
  const [loanRealtor, setRealtor] = useState();
  const [Contactdata, setContactdata] = useState();
  const [BannerData, setBannerData] = useState();
  const [dateTime, setDateTime] = useState(null);
  const [pressReleaseList, setPressReleaseList] = useState([]);
  const [loading, setLoading] = useState(true); // Assuming you need a loading state

  const [showOtherComponents, setShowOtherComponents] = useState(false);

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.offsetHeight;

    const scrollPosition =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    const maxScroll = documentHeight - windowHeight;
    const percentage = (scrollPosition / maxScroll) * 100;
    if (percentage > 0) {
      setShowOtherComponents(true);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount
  useEffect(() => {
    const removeListener = () => {
      if (showOtherComponents)
        window.removeEventListener("scroll", handleScroll);
    };
    removeListener();
  }, [showOtherComponents]);

  const [deviceType, setDeviceType] = useState(
    window.innerWidth < 575 ? "mobile" : "desktop"
  );

  useEffect(() => {
    if (window.innerWidth < 767) {
      (function (d) {
        var s = d.createElement("script");
        s.setAttribute("data-position", 2);
        s.setAttribute("data-size", "small");
        s.setAttribute("data-type", "2");
        s.setAttribute("data-mobile", true);
        s.setAttribute("defer", true);
        s.setAttribute("data-account", "RF3LDqOACA");
        s.setAttribute("src", "https://cdn.userway.org/widget.js");
        (d.body || d.head).appendChild(s);
      })(document);
    } else {
      (function (d) {
        var s = d.createElement("script");
        s.setAttribute("data-position", 6);
        s.setAttribute("data-size", "small");
        s.setAttribute("data-type", "2");
        s.setAttribute("defer", true);
        s.setAttribute("data-mobile", true);
        s.setAttribute("data-account", "RF3LDqOACA");
        s.setAttribute("src", "https://cdn.userway.org/widget.js");
        (d.body || d.head).appendChild(s);
      })(document);
    }
  });

  useEffect(() => {
    window.addEventListener("resize", () => {
      setDeviceType(window.innerWidth < 575 ? "mobile" : "desktop");
    });

    if (pressReleaseList.length === 0) {
      axios.get(`${process.env.REACT_APP_PRESS_RELEASES}?timestamp=${Date.now()}`).then((res) => {
        const arrayWithLatestDates = getSortedJsonWrtDates(res.data);
        setPressReleaseList(arrayWithLatestDates);
      });
    }

    return () => {
      window.removeEventListener("resize", () => {});
    };
  });

  useEffect(() => {
    const fetchdpaJSON = async () => {
      try {
        const loanOfficerResponse = await axios.get(
          process.env.REACT_APP_CDN_URL +
            "includes/" +
            lowerCaseLoanOfficerName +
            ".json?timestamp=" +
            Date.now()
        );

        const loanOfficerData = loanOfficerResponse.data;

        // Check if loanOfficer is null or undefined
        if (!loanOfficerData.Loanofficer) {
          window.location.replace("https://www.swmc.com/leadership/");
          return;
        }

        setLoanOfficer(loanOfficerData.Loanofficer);
        setRealtor(loanOfficerData.RealtorData);
        setContactdata(loanOfficerData.ContactData);
        setDateTime(loanOfficerData.dateandTime);
        setBannerData(loanOfficerData.lobannerData);

        const dpaDataResponse = await axios.get(
          `${process.env.REACT_APP_LEADERSHIP_JSON}?timestamp=${Date.now()}`
        );
        setDPAData(dpaDataResponse.data);
        setLoading(false); // Stop loading once data is fetched
      } catch (error) {
        console.error("Error fetching loan officer data:", error);
        window.location.replace("https://www.swmc.com/leadership/");
        window.location.replace(process.env.PUBLIC_URL);
        setLoading(false); // Stop loading in case of error too
      }
    };

    fetchdpaJSON();
  }, [lowerCaseLoanOfficerName]);

  const [links, setLinks] = useState(null); // Set initial state as null
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  if (dpaData) {
    const lobannerData = dpaData.LObanner;

    return (
      <>
        <Helmet>
          <link
            rel="canonical"
            href={
              "https://www.angelai.com/leadership/" +
              lowerCaseLoanOfficerName +
              "/"
            }
          />
        </Helmet>
        <>
          <HeaderNavbar loanRealtor={loanRealtor} />
          {BannerData ? (
            <Banner
              lobannerData={lobannerData}
              loanOfficer={loanOfficer}
              loanRealtor={loanRealtor}
              BannerData={BannerData}
              dateTime={dateTime}
              fetchpriority="high"
            />
          ) : (
            ""
          )}

          <MediaQuery minWidth={768}>
            <Suspense fallback={<div>Loading...</div>}>
              <AboutSection BannerData={BannerData} />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
              <ForbeCarousel />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
              <Broadcast />
            </Suspense>
            {showOtherComponents && (
              <>
                <Suspense fallback={<div>Loading...</div>}>
                  <PressRelease
                    deviceType={deviceType}
                    pressReleaseList={pressReleaseList}
                    pressReleaseTitle="Press Release"
                  />
                </Suspense>
                {/* <SocialMedia /> */}
                <Suspense fallback={<div>Loading...</div>}>
                  <AngelSection
                    lobannerData={lobannerData}
                    loanOfficer={loanOfficer}
                    loanRealtor={loanRealtor}
                    BannerData={BannerData}
                    dateTime={dateTime}
                  />
                </Suspense>
                <Suspense fallback={<div>Loading...</div>}>
                  <div>
                    <Footer
                      fetchpriority="low"
                      links={links.current}
                      loanOfficer={loanOfficer}
                    />
                  </div>
                </Suspense>
              </>
            )}
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <Suspense fallback={<div>Loading...</div>}>
              <AboutSection BannerData={BannerData} />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
              <ForbeCarousel />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
              <Broadcast />
            </Suspense>
            {showOtherComponents && (
              <>
                <Suspense fallback={<div>Loading...</div>}>
                  <PressRelease
                    deviceType={deviceType}
                    pressReleaseList={pressReleaseList}
                    pressReleaseTitle="Press Release"
                  />
                </Suspense>
                {/* <SocialMedia /> */}
                <Suspense fallback={<div>Loading...</div>}>
                  <AngelSection
                    lobannerData={lobannerData}
                    loanOfficer={loanOfficer}
                    loanRealtor={loanRealtor}
                    BannerData={BannerData}
                    dateTime={dateTime}
                  />
                </Suspense>
                <Suspense fallback={<div>Loading...</div>}>
                  <div>
                    <Footer
                      fetchpriority="low"
                      links={links.current}
                      loanOfficer={loanOfficer}
                    />
                  </div>
                </Suspense>
              </>
            )}
          </MediaQuery>
        </>
      </>
    );
  } else {
    return <></>;
  }
}
